import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Vardiya olayları (Prompt 13 — A aşaması). Kapanış / onay / Z raporu / gün sonu olayları B ve C aşamalarında
 * bu dosyaya eklenecektir.
 *
 * Yük KİŞİSEL VERİ TAŞIMAZ (personel adı, plaka yok): kiracıdaki tüm oturumlara gidebilir (KVKK, AGENTS.md §3.14).
 * Kimlikler taşınır; adı isteyen istemci yetki denetimli okuma ucundan çeker.
 */
export const shiftOpenedV1 = defineEvent({
    type: "shifts.shift.opened",
    version: 1,
    description: "Vardiya açıldı (üyeler, atamalar ve açılış endeksleri yazıldı)",
    realtime: ["station"],
    payload: z.object({
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        shiftNo: z.string(),
        businessDate: z.iso.date(),
        openedAt: z.iso.datetime({ offset: true }),
        templateId: z.uuid().nullable(),
        memberCount: z.number().int().nonnegative(),
        nozzleCount: z.number().int().nonnegative(),
        openingFloatTotal: z.string().describe("Devir parası toplamı (kuruş)"),
        /** Önceki vardiya kapanmadan açıldıysa true (gerekçe belgededir; olayda taşınmaz). */
        previousUnclosed: z.boolean(),
    }),
});
export const shiftCancelledV1 = defineEvent({
    type: "shifts.shift.cancelled",
    version: 1,
    description: "Yanlış açılan vardiya iptal edildi (devir parası hazine kaydı geri alındı)",
    realtime: ["station"],
    payload: z.object({
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        shiftNo: z.string(),
        businessDate: z.iso.date(),
    }),
});
export const shiftAssignmentHandedOverV1 = defineEvent({
    type: "shifts.assignment.handed_over",
    version: 1,
    description: "Vardiya içi devir: tabanca sorumluluğu ara endeksle başka kişiye geçti",
    realtime: ["station"],
    payload: z.object({
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        fromMemberId: z.uuid().nullable(),
        toMemberId: z.uuid(),
        at: z.iso.datetime({ offset: true }),
        nozzleIds: z.array(z.uuid()),
    }),
});
export const shiftCashDropRecordedV1 = defineEvent({
    type: "shifts.cash_drop.recorded",
    version: 1,
    description: "Ara teslim: pompacının üzerindeki nakit kasaya bırakıldı (hazine kaydı EXTERNAL)",
    realtime: ["station"],
    payload: z.object({
        dropId: z.uuid(),
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        memberId: z.uuid(),
        cashRegisterId: z.uuid(),
        amount: z.string().describe("Kuruş"),
        droppedAt: z.iso.datetime({ offset: true }),
        cancelled: z.boolean().describe("true → ara teslim iptal edildi (ters kayıt)"),
    }),
});
export const shiftClosingDifferenceExceededV1 = defineEvent({
    type: "shifts.closing.difference_exceeded",
    version: 1,
    description: "Pompacı / kasiyer hesabının farkı toleransı aştı (alarm; onay motoruna gitti)",
    realtime: ["station"],
    payload: z.object({
        closingId: z.uuid(),
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        memberId: z.uuid(),
        shiftNo: z.string(),
        businessDate: z.iso.date(),
        expectedAmount: z.string().describe("Kuruş"),
        declaredTotal: z.string().describe("Kuruş"),
        difference: z.string().describe("Kuruş, işaretli (eksi = açık)"),
        toleranceLimit: z.string().describe("Kuruş"),
        outcome: z.enum(["SHORTAGE", "SURPLUS"]),
        /** Onay talebi `PENDING` ise talep kimliği; politika yoksa (AUTO_APPROVED) yine dolar. */
        approvalRequestId: z.uuid().nullable(),
        requiresApproval: z.boolean().describe("true → hesap PENDING_APPROVAL'da bekliyor"),
    }),
});
export const shiftClosingAcceptedV1 = defineEvent({
    type: "shifts.closing.accepted",
    version: 1,
    description: "Hesap kabul edildi: kapanış nakdi hazineye girdi, fark karşılığı yazıldı",
    realtime: ["station"],
    payload: z.object({
        closingId: z.uuid(),
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        memberId: z.uuid(),
        kind: z.enum(["ATTENDANT", "CASHIER"]),
        expectedAmount: z.string().describe("Kuruş"),
        declaredTotal: z.string().describe("Kuruş"),
        difference: z.string().describe("Kuruş, işaretli"),
        settlementTarget: z.enum(["PERSONNEL", "EXPENSE", "SURPLUS"]).nullable(),
        /** Kasaya giren tutar = sayılan nakit + nakitten ödenen masraf (ADR 0013 karar 8). */
        cashIn: z.string().describe("Kuruş"),
    }),
});
export const shiftClosedV1 = defineEvent({
    type: "shifts.shift.closed",
    version: 1,
    description: "Vardiya kapandı: tüm hesaplar kabul edildi (gün sonuna onaylanarak girer)",
    realtime: ["station"],
    payload: z.object({
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        shiftNo: z.string(),
        businessDate: z.iso.date(),
        closingCount: z.number().int().nonnegative(),
        expectedTotal: z.string().describe("Kuruş"),
        declaredTotal: z.string().describe("Kuruş"),
        shortageTotal: z.string().describe("Kuruş (mutlak)"),
        surplusTotal: z.string().describe("Kuruş"),
    }),
});
export const shiftApprovedV1 = defineEvent({
    type: "shifts.shift.approved",
    version: 1,
    description: "Vardiya onaylandı (gün sonu ön koşulu karşılandı)",
    realtime: ["station"],
    payload: z.object({
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        shiftNo: z.string(),
        businessDate: z.iso.date(),
        /** Onaylayan kişi bu vardiyanın ÜYESİ mi (kendi hesabını onayladı mı) — risk izleme. */
        approverIsMember: z.boolean(),
    }),
});
export const shiftZReportMismatchV1 = defineEvent({
    type: "shifts.z_report.mismatch",
    version: 1,
    description: "Z raporu ile sistemin o iş günü satışı arasındaki fark eşiği aştı (alarm)",
    realtime: ["station"],
    payload: z.object({
        zReportId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        fiscalDeviceId: z.uuid(),
        serialNo: z.string(),
        scope: z.enum(["FUEL", "MARKET", "ALL"]),
        businessDate: z.iso.date(),
        zNo: z.number().int(),
        zTotal: z.string().describe("Kuruş"),
        systemAmount: z.string().describe("Kuruş"),
        difference: z.string().describe("Kuruş, işaretli (Z − sistem)"),
        threshold: z.string().describe("Kuruş"),
        /** true → aynı kapsamda birden çok cihaz var; karşılaştırma Σ Z ↔ sistem üzerinden yapıldı. */
        comparedAsGroup: z.boolean(),
        /** true → günün hesapları henüz tamamlanmamıştı; sonuç gün sonunda tazelenecek. */
        provisional: z.boolean(),
    }),
});
export const shiftDayClosedV1 = defineEvent({
    type: "shifts.day.closed",
    version: 1,
    description: "İş günü kapatıldı ve kilitlendi (gelir / KDV / tahsilat özet fişi kesildi)",
    realtime: ["station"],
    payload: z.object({
        dayClosingId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        businessDate: z.iso.date(),
        closedAt: z.iso.datetime({ offset: true }),
        shiftCount: z.number().int().nonnegative(),
        expectedAmount: z.string().describe("Kuruş, KDV dâhil ciro"),
        saleLitres: z.string().describe("Litre (3 ondalık)"),
        shortage: z.string().describe("Kuruş (mutlak)"),
        surplus: z.string().describe("Kuruş"),
        /** Ürün bazında litre / tutar (mobil sabah özeti bunu kullanır). */
        byProduct: z.array(z.object({
            productId: z.uuid(),
            saleLitres: z.string(),
            gross: z.string(),
        })),
        /** Tahsilat kırılımı: `CASH` + tahsilat türleri → kuruş. */
        collections: z.array(z.object({ kind: z.string(), amount: z.string() })),
        salesEntryId: z.uuid().nullable(),
        salesLedgerStatus: z.enum(["NONE", "POSTED", "QUEUED"]),
        warnings: z.array(z.string()),
    }),
});
export const shiftOpenTooLongV1 = defineEvent({
    type: "shifts.shift.open_too_long",
    version: 1,
    description: "Vardiya ayardaki süreden uzun süredir açık kaldı (alarm; vardiya başına bir kez)",
    realtime: ["station"],
    payload: z.object({
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        shiftNo: z.string(),
        businessDate: z.iso.date(),
        openedAt: z.iso.datetime({ offset: true }),
        openHours: z.number().int().nonnegative(),
        thresholdHours: z.number().int().positive(),
    }),
});
export const shiftDayUnclosedV1 = defineEvent({
    type: "shifts.day.unclosed",
    version: 1,
    description: "İş günü gün sonu yapılmadan bekliyor (alarm; gün başına bir kez)",
    realtime: ["station"],
    payload: z.object({
        dayClosingId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        businessDate: z.iso.date(),
        /** `READY` → tüm vardiyalar onaylı, gün sonu bekliyor; `STALE` → dünden kalan açık vardiya var. */
        reason: z.enum(["READY", "STALE"]),
        shiftCount: z.number().int().nonnegative(),
        hoursWaiting: z.number().int().nonnegative(),
    }),
});
export const shiftCreditSaleRecordedV1 = defineEvent({
    type: "shifts.credit_sale.recorded",
    version: 1,
    description: "Veresiye / filo fişi kesildi; cari açık kalemi oluştu (muhasebe fişi gün sonundadır)",
    realtime: ["station"],
    payload: z.object({
        saleId: z.uuid(),
        shiftId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        memberId: z.uuid(),
        counterpartyId: z.uuid(),
        kind: z.enum(["ON_ACCOUNT", "FLEET"]),
        amount: z.string().describe("Kuruş, KDV dâhil"),
        occurredAt: z.iso.datetime({ offset: true }),
        /** Limit aşımı yetkiliyle geçildiyse true (risk izleme). */
        creditLimitOverridden: z.boolean(),
        cancelled: z.boolean().describe("true → fiş iptal edildi (açık kalem de iptal)"),
    }),
});
//# sourceMappingURL=shifts.v1.js.map